module.exports = __webpack_public_path__ + "static/media/ic-school-gray-24-px.061f3dac.svg";